<div class="page-header-container">
    <div class="page-title">
        <button class="btn link-btn btn-back">
            <i class="app-icon icon icon-chevron-left icon-xxl" (click)="redirectRequestTypeHandler()"></i>
        </button>
        {{'requests.clientData.title' | translate}}
    </div>
</div>

<div class="header-buttons-box">
    <button *ngIf="activeFilterCount <= 0" class="btn white-btn text-uppercase" (click)="filterHandler()">
        {{'request.filter' | translate}}
    </button>
    
    <div class="buttons-group-box active-filters-reset" *ngIf="activeFilterCount > 0">
        <div class="btn-group" role="group">
            <button class="btn white-btn text-uppercase" (click)="filterHandler()">
                <span>{{'request.filterActive' | translate}}</span>
            </button>
            <button class="btn white-btn" (click)="resetFiltersHandler()">
                <span class="active-filters-badge">{{activeFilterCount}}</span>
                <i class="app-icon icon icon-close-circle-fill icon-lg"></i>
            </button>
        </div>
    </div>
    
    <button class="btn primary-btn" [hidden]= "readOnly"  (click)="createNewRequest()">
        {{'requests.cards.addNewRequest' | translate}}
    </button>
</div>

<div *ngIf="!hasData && !isFiltered" class="d-flex flex-column align-items-center">
    <no-records-placeholder
        [showNoRecordsHeader]="true"
        noRecordsHeader="requests.clientData.noRecords"
        noRecordsSubheaderText1=""
        noRecordsSubheaderText2=""
        noRecordsSubheaderText3=""
    ></no-records-placeholder>
</div>

<div *ngIf="!hasFilterData && isFiltered" class="d-flex flex-column align-items-center my-5 my-lg-0">
    <no-records-placeholder
        [showNoRecordsHeader]="true"
        [isActiveFilter]="activeFilterCount > 0"
        (clickHereEvent)="resetFiltersHandler()"
    ></no-records-placeholder>
</div>

<client-data-card-view *ngIf="hasData && hasFilterData"
    [requests]="requests"
    [props]="requestsProps"
    [detailsHandler]="viewDetailsHandler">
</client-data-card-view>

<button *ngIf="showBackToTop" type="button" class="btn btn-scroll-to-top" (click)="scrollToTop()">
    <i class="app-icon icon icon-back-to-top icon-xl"></i>
</button>
